/* eslint-disable no-shadow */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { submitUpdate } from "../../../actions/agencyProfileActions";
import qualificationTechniquesType from "../types/qualificationTechniquesType";
import Warning from "./Warning";
import Button from "../../shared/button/Button";
import WidgetLoading from "../../shared/loaders/WidgetLoading";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  Paragraph,
  Form,
  Field,
  TextInput,
  Info,
  CloseButton,
  Buttons,
} from "./styles/qualifications-edit-styles";

export class QualificationsEdit extends Component {
  constructor(props) {
    super(props);
    const { qualificationTechniques, userId } = this.props;

    this.state = {
      qualificationTechniques,
      userId,
      warningActive: false,
      focusedFieldId: null,
    };
  }

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  handleChange = (e, id) => {
    const { qualificationTechniques } = this.state;
    const newQualificationTechniques = [...qualificationTechniques];
    newQualificationTechniques[id] = e.target.value;

    this.setState({
      qualificationTechniques: newQualificationTechniques,
    });
  };

  setFocusedFieldId = (id) => {
    this.setState({
      focusedFieldId: id,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitUpdate, toggleEditQualifications } = this.props;
    const { qualificationTechniques, userId } = this.state;

    submitUpdate(
      {
        userId,
        qualificationTechniques: [
          ...new Set(qualificationTechniques.filter(Boolean)),
        ],
      },
      toggleEditQualifications,
      "QUALIFICATIONS"
    );
  };

  render() {
    const { warningActive, qualificationTechniques, focusedFieldId } =
      this.state;
    const { toggleEditQualifications, qualificationsFormLoading } = this.props;

    return (
      <Backdrop className="animated fadeIn">
        <ModalWrapper className="animated delay-1 fadeInDown">
          {qualificationsFormLoading && <WidgetLoading />}
          {warningActive && (
            <Warning
              toggleWarning={this.toggleWarning}
              closeForm={toggleEditQualifications}
            />
          )}
          <Title>
            <TitleText>Edit Candidate Qualification</TitleText>
            <CloseButton onClick={this.toggleWarning}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Title>
          <Body>
            <Paragraph>
              I qualify my candidates using the following techniques:
            </Paragraph>
            <Form>
              <Field>
                <TextInput
                  maxLength={35}
                  type="text"
                  placeholder="Add a new technique"
                  value={qualificationTechniques[0] || ""}
                  onChange={(e) => this.handleChange(e, 0)}
                  onFocus={() => this.setFocusedFieldId(0)}
                  onBlur={() => this.setState({ focusedFieldId: null })}
                />
                {focusedFieldId === 0 && <Info>Maximum of 35 characters</Info>}
              </Field>
              <Field>
                <TextInput
                  maxLength={35}
                  type="text"
                  placeholder="Add a new technique"
                  value={qualificationTechniques[1] || ""}
                  onChange={(e) => this.handleChange(e, 1)}
                  onFocus={() => this.setFocusedFieldId(1)}
                  onBlur={() => this.setState({ focusedFieldId: null })}
                />
                {focusedFieldId === 1 && <Info>Maximum of 35 characters</Info>}
              </Field>
              <Field>
                <TextInput
                  maxLength={35}
                  type="text"
                  placeholder="Add a new technique"
                  value={qualificationTechniques[2] || ""}
                  onChange={(e) => this.handleChange(e, 2)}
                  onFocus={() => this.setFocusedFieldId(2)}
                  onBlur={() => this.setState({ focusedFieldId: null })}
                />
                {focusedFieldId === 2 && <Info>Maximum of 35 characters</Info>}
              </Field>
              <Field>
                <TextInput
                  maxLength={35}
                  type="text"
                  placeholder="Add a new technique"
                  value={qualificationTechniques[3] || ""}
                  onChange={(e) => this.handleChange(e, 3)}
                  onFocus={() => this.setFocusedFieldId(3)}
                  onBlur={() => this.setState({ focusedFieldId: null })}
                />
                {focusedFieldId === 3 && <Info>Maximum of 35 characters</Info>}
              </Field>
              <Field>
                <TextInput
                  maxLength={35}
                  type="text"
                  placeholder="Add a new technique"
                  value={qualificationTechniques[4] || ""}
                  onChange={(e) => this.handleChange(e, 4)}
                  onFocus={() => this.setFocusedFieldId(4)}
                  onBlur={() => this.setState({ focusedFieldId: null })}
                />
                {focusedFieldId === 4 && <Info>Maximum of 35 characters</Info>}
              </Field>
              <Field>
                <TextInput
                  maxLength={35}
                  type="text"
                  placeholder="Add a new technique"
                  value={qualificationTechniques[5] || ""}
                  onChange={(e) => this.handleChange(e, 5)}
                  onFocus={() => this.setFocusedFieldId(5)}
                  onBlur={() => this.setState({ focusedFieldId: null })}
                />
                {focusedFieldId === 5 && <Info>Maximum of 35 characters</Info>}
              </Field>
              <Buttons>
                <Button
                  primary
                  buttonName="Save"
                  onClickAction={this.handleSubmit}
                />
              </Buttons>
            </Form>
          </Body>
        </ModalWrapper>
      </Backdrop>
    );
  }
}

QualificationsEdit.propTypes = {
  qualificationTechniques: qualificationTechniquesType.isRequired,
  toggleEditQualifications: PropTypes.func.isRequired,
  submitUpdate: PropTypes.func.isRequired,
  qualificationsFormLoading: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  qualificationTechniques:
    state.agencyProfile.profileData.qualificationTechniques,
  qualificationsFormLoading: state.agencyProfile.qualificationsFormLoading,
  userId: state.agencyProfile.profileData.user.id,
});

export default connect(mapStateToProps, { submitUpdate })(QualificationsEdit);
